const state = {
  trainer: {},
  istrainer:true
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/trainer/state.js